import { render, staticRenderFns } from "./HandleProjectStatusTabGeneral.vue?vue&type=template&id=73f05304"
import script from "./HandleProjectStatusTabGeneral.vue?vue&type=script&lang=js"
export * from "./HandleProjectStatusTabGeneral.vue?vue&type=script&lang=js"
import style0 from "./HandleProjectStatusTabGeneral.vue?vue&type=style&index=0&id=73f05304&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports